<template>
  <div id="floatingSupport">
    <div id="contactModal" class="modal z-depth-light-1 white" ref="contactModal">
      <div class="modal-content">
        <div class="contactNav" v-if="currentlyShowing === 'nav'">
          <div class="header">
            <span class="title">Are you having an issue with the App?</span>
            <span class="message">If you are having any issues using the Application, please use
              the form below to send us a short message explaining the
              issue.</span>
          </div>
          <div class="close-header">
            <button class="btn-floating waves modal-close effect transparent z-depth-0 btn-small grey-text text-darken-2">
              <i class="material-icons grey-text text-darken-2">close</i>
            </button>
          </div>
          <div class="contents">
            <ul>
              <li class="waves-effect" @click="$_formShow('contactUs')">
                <a>Send us a message
                  <i class="material-icons right">keyboard_arrow_right</i></a>
              </li>
              <li class="waves-effect hide">
                <a :disabled="true" :class="messages.length < 1 ? 'grey-text text-darken-1' : ''">Your Messages</a>
                <span class="badge indigo accent-2 circular white-text">{{
                  messages.length
                }}</span>
              </li>
              <!--    <li class="waves-effect"  @click="$_formShow('call')">
              <a>Call Us? <i class="material-icons right">keyboard_arrow_right</i></a>
            </li> -->
            </ul>
          </div>
        </div>

        <div class="contactForm" v-if="currentlyShowing === 'contactUs'">
          <div class="header-area">
            <button @click="$_formShow('nav')" class="btn-floating white z-depth-0 left">
              <i class="material-icons grey-text text-darken-3">arrow_back</i>
            </button>
            <div class="title-area">Support Contact</div>
          </div>
          <div class="clear"></div>
          <contact-form @back="$_formShow('nav')"></contact-form>
        </div>
      </div>
    </div>
    <button class="btn-floating btn-large indigo accent-2 tooltipped" @click="$_initModal()" v-if="inView"
      data-position="left" data-tooltip="Report an Issue">
      <i class="material-icons-outlined white-text">contact_support</i>
    </button>
    <!-- <button
    @click="$_initModal()"
    class=" btn white grey-text text-darken-3 waves-effect white z-depth-light-1">
    <i class="material-icons left">mail</i> have questions ? </button> -->
  </div>
</template>
<script>
import contactForm from "@/components/contactForm.component";
/* import core from '@/functions' */
import { mapState } from "vuex";
import M from "materialize-css";
const core = [];
export default {
  name: "supportForm",
  components: {
    contactForm,
  },
  props: {
    inView: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    '$route.name': function (nV) {
      if (nV) {
        this.resetTooltip = false
        setTimeout(() => {
          this.resetTooltip = true
        }, 1500);
      }
    },
  },
  data() {
    let vm = this;
    return {
      resetTooltip: true,
      currentlyShowing: "nav",
      modalInstance: Object,
      modalOptions: {
        opacity: 0,
        preventScrolling: false,
        onCloseEnd: () => {
          vm.modalInstance.destroy();
        },
      },
      tooltip: {
        instance: null,
        options: {
          outDuration: 100,
        },
      },
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.User.user,
    }),
    messages: {
      get() {
        return []
        let mailBox = this.user.messages ? JSON.parse(this.user.messages) : [];
        return mailBox;
      },
    },
  },
  mounted() {
    // Initialize Tooltip
    this.tooltip.instance = M.Tooltip.init(
      this.$el.querySelector(".tooltipped"),
      this.tooltip.options
    );
  },
  beforeDestroy() {
    if (this.tooltip.instance) {
      this.tooltip.instance.destroy();
    }
  },
  methods: {
    $_initModal() {
      this.tooltip.instance.close();

      this.modalInstance = M.Modal.init(
        this.$refs.contactModal,
        this.modalOptions
      );

      setTimeout(() => {
        this.modalInstance.open();
      }, 150);
    },
    $_formShow(e) {
      this.currentlyShowing = e;
    },
  },
};
</script>
<style lang="scss" scoped>
#floatingSupport {
  position: fixed;
  right: 10px;
  z-index: 999;
  bottom: 72px;

  div#contactModal {
    right: 24px !important;
    left: inherit;
    border-radius: 8px;
    bottom: 68px;
    top: initial !important;
    max-width: 450px;
    width: 100%;
    height: 70vh;

    @media screen and (max-width: 680px) {
      right: 5% !important;
      left: 5%;
      max-width: 360px;
      width: 90%;
    }

    .modal-content {
      padding: 0px;
    }
  }

  .close-header {
    display: inline-block;
    right: 0;
    position: absolute;
    top: 0;
    padding: 12px;
  }

  .contents {
    width: 100%;
    min-height: 300px;

    ul {
      padding: 0px;
      margin: 0;
      width: 100%;

      li {
        padding: 16px;
        width: 100%;
        border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
      }
    }
  }

  .header {
    padding: 24px 24px 16px 24px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  }

  span {
    &.title {
      font-size: 22px;
      display: flex;
    }

    &.message {
      font-size: 16px;
      display: flex;
    }
  }

  .head {
    margin-bottom: 16px;

    button {
      float: left;
      margin-right: 16px;
    }

    .title {
      font-size: 21px;
      float: left;
      line-height: 36px;
    }
  }

  .contactInfo {
    padding: 16px;

    .csPage {
      &.row {
        margin-bottom: 0px !important;

        ul {
          margin: 0px !important;

          li {
            &.numberLi {
              font-size: 21px;
              margin-bottom: 15px;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
}

.conversation {}

.contactForm {
  font-size: 14.5px;

  .header-area {
    display: flex;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    padding: 4px 16px 0 8px;
    line-height: 42px;
    height: 48px;
    position: relative;
    z-index: 9;

    button {
      margin-right: 8px;
    }

    .title-area {
      font-size: 19.5px;
      letter-spacing: 0.7px;
    }
  }
}
</style>
<style lang="scss">
.admin {
  #floatingSupport {
    display: none;
    z-index: -1;
  }
}
</style>
